import React from 'react';
import { Link } from 'react-router-dom';
import 'Styles/base/_sideBarNavigation.scss';

const RenderLinks = props => {
  const {
    links,
    index,
    collapseInactiveMenu,
    expandFirstMenu,
    activeMenu,
    selectedSubMenu,
    data,
  } = props;

  const { subMenu, icon: Icon, linkValue } = links;
  const isActiveMenu = links.linkKey === activeMenu;
  const showSubMenu =
    !collapseInactiveMenu ||
    (collapseInactiveMenu && isActiveMenu) ||
    (expandFirstMenu && index === 0);
  const hasSubMenu = subMenu?.length > 0 && showSubMenu;

  const className = `main-text${isActiveMenu ? ' active' : ''}${
    hasSubMenu ? ' has-sub-menu' : ''
  }${index !== data.sublinks?.length - 1 ? ' not-last' : ''}`;

  const mainMenu = (
    <>
      {Icon ? <Icon className="nav-icon" /> : ''}
      <span>{links.titleText}</span>
    </>
  );

  return (
    <div
      className="row no-gutters integration-nav-link"
      key={`${data.title}-${links.linkKey}`}
    >
      <Link
        to={linkValue}
        className={`${links.linkKey} ${className} menu-link`}
      >
        {mainMenu}
      </Link>
      {hasSubMenu && (
        <div className="sub-menu">
          {subMenu.map(menu => {
            return (
              <Link
                key={`${data.title}-${links.linkKey}-${menu.API_KEY ??
                  menu.title}`}
                to={menu.link}
                className={`sub-menu-link${
                  selectedSubMenu === menu.title.toLowerCase() && isActiveMenu
                    ? ' selected'
                    : ''
                }`}
              >
                {menu.title}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};

function SideBarNavigation(props) {
  const {
    data,
    activeMenu,
    selectedSubMenu,
    connectionStatus,
    hasIcon = true,
    collapseInactiveMenu = false,
    expandFirstMenu = false,
    customRenderList = null,
    children,
  } = props;

  const Image = data?.imgComponent;

  return (
    <div className="sidebar-section">
      <div className="sidebar-header">
        <div>
          {hasIcon ? (
            data.isSvg ? (
              <Image className="logo" />
            ) : (
              <img src={Image} alt={data.title} className="logo" />
            )
          ) : null}
        </div>
        <div className="title-wrapper">
          <span className="title-text">{data.title}</span>
          {connectionStatus && (
            <span
              className={`connection-status${
                connectionStatus.toLowerCase() === 'connected' ? '' : ' red'
              }`}
            >
              {connectionStatus}
            </span>
          )}
        </div>
        {/* <span className="menu-icon">
  		         <TripleDotNavIcon />
  		       </span> */}
      </div>
      <div className="sidebar-navigation">
        {data.sublinks?.map((links, index) => {
          const propsToPass = {
            data,
            links,
            index,
            activeMenu,
            selectedSubMenu,
            collapseInactiveMenu,
            expandFirstMenu,
          };
          if (customRenderList !== null) return customRenderList(propsToPass);
          return <RenderLinks {...propsToPass} key={index} />;
        })}
      </div>
      {children}
    </div>
  );
}

export default SideBarNavigation;
